import { fetchAvailabilities } from 'reservations/availabilities/queries/fetchAvailabilities';
import type { UseAvailabilitiesQuery } from 'reservations/availabilities/types';
import { DEFAULT_QUERY_OPTIONS } from 'reservations/base/constants/queryOptions';

type UseCalendarAvailabilitiesQuery = Omit<UseAvailabilitiesQuery, 'date'> & {
  beginDateTime: string;
  endDateTime: string;
  excludeTimeSlots: boolean;
};

export function getCalendarAvailabilities({
  partySize,
  beginDateTime,
  endDateTime,
  apiKey,
  slug,
  excludeTimeSlots
}: UseCalendarAvailabilitiesQuery) {
  return {
    queryKey: [
      'bentoboxReservations',
      'availabilities-no-slots',
      slug,
      partySize,
      beginDateTime,
      endDateTime
    ],
    queryFn: () =>
      fetchAvailabilities({
        partySize,
        apiKey,
        beginDateTime,
        endDateTime,
        excludeTimeSlots
      }),
    ...DEFAULT_QUERY_OPTIONS
  };
}
